import { IGoogleMapRepository } from "@/repositories";
import { IGoogleMapService } from "./googlemap.types";

export class GoogleMapService implements IGoogleMapService {
    constructor(private repository: IGoogleMapRepository) {

    }

    async getPlaceList(input: string, location: string, radius: string, language = "thai"): Promise<any> {
        return await this.repository.getPlaceList(input, location, radius, language)
    }
    async getDetails(placeId: string, fields: string[]): Promise<any> {
        return await this.repository.getDetails(placeId, fields)
    }
    async geocode(location: string): Promise<any> {
        return await this.repository.geocode(location)
    }

}